<template lang="pug">
.ProfileChildComponent
  .infoWrapper
    .title Данные ребенка
    .avatarWrapper
      ui-avatar(
        :url="child.avatarUrl"
        :size="170"
        :borderRadius="50"
      )
    .dataList
      .dataItem
        label Имя
        span.fname {{ child.firstName }}
      .dataItem
        label Год рождения
        span.fname {{ child.birthDate?.year() ?? 'Не указан' }}
      .dataItem
        label Пол
        span.fname {{ child.genderText }}
</template>

<script>
import UserChild from '@/models/UserChild'
export default {
  props: {
    child: {
      type: UserChild,
      required: true
    }
  }
}
</script>

<style lang="sass" scoped>
.ProfileChildComponent
  display: flex
  @include gap(7.5*$u)

  > .infoWrapper
    width: 100%
    padding-left: 40%
    position: relative

    > .title
      @include font('h2')
      margin-bottom: 6*$u

    > .avatarWrapper
      position: absolute
      left: 0
      top: 0
    > .dataList
      margin-bottom: 12.5*$u

      > .dataItem
        display: flex
        @include gap(5*$u)
        align-items: center
        @media (max-width: $padWidth)
          @include gap(4*$u)
        @media (max-width: $mobileWidth)
          @include gap(3*$u)

        &:not(:last-child)
          margin-bottom: 5*$u

        > label
          @include font('t18-regular')
          color: $cDarkGrey
        > span
          @include font('t18-regular')
          color: $cText
          overflow: hidden
          text-overflow: ellipsis
          white-space: nowrap

@media (max-width: $XXSWidth)
  .ProfileChildComponent
    .infoWrapper
      padding-left: 0
      .title
        margin-bottom: 5*$u
      .avatarWrapper
        position: static
        margin-bottom: 5*$u
      .dataList
        .dataItem
          margin-bottom: 4*$u !important
</style>
